export default __webpack_public_path__ + "static/media/seedfund.06bb2319.svg";